'use client';

import { Drawer } from '@ui/components/common/drawer';

import { ShareOptionsContent, ShareOptionsContentProps } from './ShareOptionsContent';

export interface ShareOptionsDrawerProps extends ShareOptionsContentProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
}

export function ShareOptionsDrawer({
  isOpen,
  onClose,
  profileUrl,
  userName,
  translations,
  title = 'Share via'
}: ShareOptionsDrawerProps) {
  return (
    <Drawer
      trigger={<div style={{ display: 'none' }} />}
      side="bottom"
      open={isOpen}
      onOpenChange={onClose}
      title={title}
      className="px-5 pt-2 rounded-t-lg"
    >
      <ShareOptionsContent profileUrl={profileUrl} userName={userName} translations={translations} onClose={onClose} />
    </Drawer>
  );
}
